import { Box, Button, Grid, styled, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import React from "react";
import { Link } from "react-router-dom";
import { convertDate } from "../utils/dateConvert";
import { JobResponse } from "../models/Job";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "20px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

const TitleItemGrid = styled(Grid)({
  fontWeight: "bold",
  paddingLeft: "1%",
});

const SubTitleItemGrid = styled(Grid)({
  color: "#524B6B",
  paddingLeft: "1%",
});

const DateItemGrid = styled(Grid)({
  color: "#AAA6B9",
  paddingLeft: "1%",
});

const EtcItemGrid = styled(Grid)({
  color: "#524B6B",
  backgroundColor: "rgba(203, 201, 212, 0.2)",
  paddingLeft: "3%",
  paddingRight: "3%",
  paddingBottom: "1%",
  paddingTop: "1%",
  borderRadius: "8px",
  margin: "1%",
});

const ClearLink = styled(Link)({
  width: "30%",
  textDecoration: "none",
  textTransform: "none",
});

const ButtonBox = styled(Box)(({ theme }) => ({
  width: "15%",
  [theme.breakpoints.down("sm")]: {
    width: "30%",
  },
}));

const RoundedButton = styled(Button)(({ theme }) => ({
  width: "100%",
  borderRadius: "90px",
  boxShadow: "none",
}));

type Props = {
  Job: JobResponse;
  ButtonLink?: string;
  ButtonText: string;
  ButtonHandler?: () => void;
  BigTitle?: boolean;
  ButtonWidth?: string;
  ButtonHidden?: boolean;
  Sizexs?: number;
  Sizemd?: number;
  Sizelg?: number;
  Sizexl?: number;
};

export default function JobCard({
  Job,
  ButtonLink,
  ButtonText,
  ButtonHandler,
  BigTitle = false,
  ButtonWidth = "30%",
  ButtonHidden = false,
  Sizexs = 11,
  Sizemd = 5,
  Sizelg = 11 / 3,
  Sizexl = 11 / 3,
}: Props) {
  return (
    <SquareGrid
      container
      item
      direction="row"
      xs={Sizexs}
      md={Sizemd}
      lg={Sizelg}
      xl={Sizexl}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        item
        xs={12}
      >
        <TitleItemGrid item lg={12}>
          <Typography variant={BigTitle ? "h4" : "h6"}>{Job.JOB}</Typography>
        </TitleItemGrid>
        <DateItemGrid item lg={12}>
          <Typography> Diunggah : {convertDate(Job.TANGGAL_DIBUAT)}</Typography>
        </DateItemGrid>
      </Grid>
      <Grid container direction="row" item xs={12}>
        <SubTitleItemGrid item xs>
          <Box
            sx={{
              display: "flex",
              padding: "3%",
            }}
          >
            <LocationOnIcon
              color="primary"
              sx={{
                paddingRight: "3%",
              }}
            />
            <Typography >
              {Job.LOKASI}
            </Typography>
          </Box>
        </SubTitleItemGrid>
      </Grid>
      <Grid container direction="row" item xs={12}>
        <EtcItemGrid item>
          <Typography>Status Karyawan : {Job.STATUS_KARYAWAN}</Typography>
        </EtcItemGrid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        item
        xs={12}
        sx={{
          visibility: ButtonHidden ? "hidden" : "visible",
          paddingTop: "1vh",
          paddingBottom: "1vh",
        }}
      >
        {ButtonLink !== undefined ? (
          <ClearLink to={ButtonLink} sx={{ width: ButtonWidth }}>
            <RoundedButton variant="contained">{ButtonText}</RoundedButton>
          </ClearLink>
        ) : (
          <ButtonBox>
            <RoundedButton variant="contained" onClick={ButtonHandler}>
              {ButtonText}
            </RoundedButton>
          </ButtonBox>
        )}
      </Grid>
    </SquareGrid>
  );
}
